
import { useStore } from '@/store'
import { defineComponent, ref } from 'vue'
import { computed } from 'vue'
import backSettings from '@/settings/back-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import Analytics from '@/singletons/analytics'
import FormScrollableTab from '@/components/Abstract/FormScrollableTab.vue'

export default defineComponent({
  name: 'FormBack',
  components: {
    FormScrollableTab,
    FormOption
  },
  props: {
    index: Number
  },
  setup() {
    const store = useStore()
    const configName = ref('configBackId')
    const config = computed(() => store.getters[configName.value])
    const options = computed(() => backSettings.backColors)

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_BACK, option.id)
      Analytics.instance.sendBackEvent(option.id)
    }

    return {
      config,
      configName,
      backSettings,
      onClick,
      options,
    }
  }
})
